import React from 'react';


const tecno = [
    { T: 'MySql', L: 'https://www.mysql.com/' },
    { T: 'Java', L: 'https://www.oracle.com/java/technologies/downloads/' },
    
    

];


class Gameover extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>Kanjaban</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <iframe  src="https://www.youtube.com/embed/0VUgrZptHR4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        
                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>Kanjaba is an application made in java using NetBeans and MySql to organize personal projects based on the kanban methodology focused on a single user.</p>

                        <a href="https://github.com/BrandonGrimaldoM/Kanjaban" target="_blank" rel="noreferrer">
                            <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Gameover;